
class Cache {
	data = {};
	
	//constructor() {}

	get(key) {
		return this.data[key] || null;
	}
	
	set(key, value) {
		this.data[key] = value;
	}
	
	has(key) {
		return this.data.hasOwnProperty(key);
	}
	
	init(key, value) {
		if (!this.has(key))
			this.set(key, value);
	}

	clear(key) {
		if (this.has(key))
			delete this.data[key];
	}
}


var cache = new Cache();
window.cache = cache;
export default cache;
